module.exports = __webpack_public_path__ + "img/card.1a3746ac.png";